import { Buffer } from 'buffer';
import crypto from 'crypto-browserify';

export const signUp = async (password) => {
  const saltArray = crypto.randomBytes(16);
  const salt = saltArray.toString('hex');

  const passwordWithSalt = password + salt;

  const hash = crypto.createHash('sha256');
  hash.update(Buffer.from(passwordWithSalt, 'utf-8'));

  const hashPassword = hash.digest('hex');

  return { salt, hashPassword };
};

export const login = (password, salt) => {
  const passwordWithSalt = password + salt;

  const hash = crypto.createHash('sha256');
  hash.update(Buffer.from(passwordWithSalt, 'utf-8'));

  const hashPassword = hash.digest('hex');

  return { salt, hashPassword };
};
